import 'css-chunksrc/client/pages/planzoneLogsPage/skeleton/styles.scss';export default {
  "skeleton": "_skeleton_188d5_1",
  "card": "_card_188d5_10"
};